import { useCallback, useState } from "react";
import AsyncState from "../AsyncState";
import { updateAsyncState } from "../Updater";
import * as Utils from "../Utils";
export function useAsyncState(defaultValue, options) {
    var _a = useState(AsyncState.create(defaultValue, options)), asyncState = _a[0], setAsyncState = _a[1];
    var updateFn = useCallback(function (promiseOrAsyncFn, options) { return updateAsyncState(setAsyncState, promiseOrAsyncFn, options); }, []);
    return [asyncState, setAsyncState, updateFn];
}
export function useAsyncStateGroup(defaultValue, defaultStateGetter) {
    var _a = useState((defaultValue || {})), stateGroup = _a[0], setStateGroup = _a[1];
    var updateStateGroup = useCallback(function (key, promiseOrAsyncFn, options) {
        return updateAsyncState(function (state) {
            return setStateGroup(function (prevState) {
                var _a;
                var newState = typeof state === "function" ? state(prevState[key] || (defaultStateGetter ? defaultStateGetter() : AsyncState.create())) : state;
                return Utils.assign({}, prevState, (_a = {}, _a[key] = newState, _a));
            });
        }, promiseOrAsyncFn, options);
    }, []);
    return [stateGroup, setStateGroup, updateStateGroup];
}
